import type { BookingDto } from '@bingo/shared';
import { useT } from '../lib/i18n';

/**
 * Time of a transfer, the same way on every screen (Bruno, 18/10): the time the team works with
 * (Prévu when set, else the official time) in front, and the official time small next to it, or
 * under it in narrow columns (stacked), when Prévu differs from it.
 */
export function TransferTime({ b, stacked }: { b: Pick<BookingDto, 'pickupTime' | 'expectedTime'>; stacked?: boolean }) {
  const t = useT();
  const changed = !!b.expectedTime && !!b.pickupTime && b.expectedTime !== b.pickupTime;
  return (
    <span className={`tr-time mono ${stacked ? 'stacked' : ''}`} title={changed ? t('Expected {exp} (official {off})', { exp: b.expectedTime!, off: b.pickupTime! }) : undefined}>
      <b>{b.expectedTime || b.pickupTime || '--:--'}</b>
      {changed && <span className="tr-time-off">{b.pickupTime}</span>}
    </span>
  );
}
